function Interviews({ profilesImage, interviews, profiles }) {
  return (
    <div className=" w-[95%] mb-10 mx-auto mt-6  grid-cols-1 grid lg:grid-cols-2 ">
      <div className="px-4 py-4">
        <div className="grid gap-8">
          {interviews?.map((interview) => (
            <div
              key={interview.id}
              className="bg-white rounded-lg shadow-md p-8 transition-transform hover:scale-[1.02]"
            >
              <div className="flex flex-col md:flex-row items-start gap-6">
                <div className="bg-gray-100 px-6 py-4 rounded-lg">
                  <span className="text-5xl font-bold text-indigo-900">
                    {interview.number}
                  </span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-indigo-900 mb-2">
                    {interview.title}
                  </h3>
                  <p className="text-gray-600  italic">
                    {interview.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="  px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-start text-indigo-900  mb-4">
            Profils Attendus
          </h2>

          <div className=" h-[400px]">
            <img className=" w-full h-full object-cover" src={profilesImage} />
          </div>

          <div className="grid md:grid-cols-3 mt-5 gap-4">
            {profiles?.map((profile, index) => (
              <div
                key={index}
                className=" transition-transform hover:scale-[1.02]"
              >
                <div className="flex flex-col items-center text-justify">
                  <h3 className="text-xl text-start font-semibold text-indigo-900 mt-4 mb-3">
                    {profile.title}
                  </h3>
                  <div className="bg-gray-200 rounded-lg  p-4 ">
                    <p className="text-gray-600">{profile.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Interviews;
